import React, { useEffect, useState, createElement } from 'react';
import { Ticket, X, User, Mail, Phone, Globe, Check, AlertCircle, BookOpen, Lock, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
declare global {
  interface Window {
    fbq: any;
  }
}
const COUNTRY_CODES = [{
  code: '+1',
  country: 'USA/Canada'
}, {
  code: '+52',
  country: 'México'
}, {
  code: '+57',
  country: 'Colombia'
}, {
  code: '+34',
  country: 'España'
}, {
  code: '+54',
  country: 'Argentina'
}, {
  code: '+56',
  country: 'Chile'
}, {
  code: '+51',
  country: 'Perú'
}, {
  code: '+593',
  country: 'Ecuador'
}, {
  code: '+58',
  country: 'Venezuela'
}, {
  code: '+502',
  country: 'Guatemala'
}, {
  code: '+503',
  country: 'El Salvador'
}, {
  code: '+504',
  country: 'Honduras'
}, {
  code: '+505',
  country: 'Nicaragua'
}, {
  code: '+506',
  country: 'Costa Rica'
}, {
  code: '+507',
  country: 'Panamá'
}, {
  code: '+591',
  country: 'Bolivia'
}, {
  code: '+595',
  country: 'Paraguay'
}, {
  code: '+598',
  country: 'Uruguay'
}, {
  code: '+1-809',
  country: 'Rep. Dominicana'
}];
export function OptinVslPage() {
  // Modal State (only for legal pages now)
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  // Form State
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [areaCode, setAreaCode] = useState('+1');
  const [phone, setPhone] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    // Load Meta Pixel
    ;
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    window.fbq('init', '754551913878347');
    window.fbq('track', 'PageView');
  }, []);
  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (!email || !name || !phone || isSubmitting) return;
    setIsSubmitting(true);
    try {
      await fetch('https://services.leadconnectorhq.com/hooks/HMYR0XQcpZnIeoWD2nrn/webhook-trigger/d1eada12-31ca-46fe-a334-a8ceb1286952', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          name,
          email,
          areaCode,
          phoneNumber: phone,
          fullPhone: `${areaCode}${phone}`,
          source: 'optin-vsl'
        })
      });
      // Redirect to VSL page after opt-in
      navigate('/vsl');
    } catch (error) {
      console.error('Error submitting form:', error);
      setIsSubmitting(false);
    }
  };
  return <div className="min-h-screen bg-[#050505] text-white font-sans selection:bg-[#FDB931] selection:text-black overflow-x-hidden" data-id="element-1880">
      {/* Meta Pixel Noscript */}
      <noscript data-id="element-1881">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=754551913878347&ev=PageView&noscript=1" alt="" data-id="element-1882" />
      </noscript>

      {/* Ambient Background Effects */}
      <div className="fixed inset-0 pointer-events-none z-0" data-id="element-1883">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-[#FDB931]/5 rounded-full blur-[120px]" data-id="element-1884" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] bg-[#FDB931]/5 rounded-full blur-[120px]" data-id="element-1885" />
        <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20 brightness-100 contrast-150 mix-blend-overlay" data-id="element-1886"></div>
      </div>

      <main className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 lg:py-16 min-h-screen flex flex-col justify-center" data-id="element-1887">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-center" data-id="element-1888">
          {/* LEFT COLUMN: Copy & Value Prop */}
          <div className="lg:col-span-7 space-y-8 text-left animate-in fade-in slide-in-from-bottom-8 duration-700" data-id="element-1889">
            {/* Tagline */}
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/5 border border-white/10 backdrop-blur-sm" data-id="element-1890">
              <span className="relative flex h-2 w-2" data-id="element-1891">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#FDB931] opacity-75" data-id="element-1892"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-[#FDB931]" data-id="element-1893"></span>
              </span>
              <span className="text-xs font-bold tracking-wider text-[#FDB931] uppercase" data-id="element-1894">
                Entrenamiento On-Demand · ~20 min
              </span>
            </div>

            {/* Headlines */}
            <div className="space-y-4" data-id="element-1895">
              <h2 className="text-lg md:text-xl font-medium text-gray-400 leading-tight" data-id="element-1896">
                Descubre por qué el problema no es la falta de ideas o
                herramientas...
              </h2>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-black uppercase tracking-tight leading-[0.95] text-white" data-id="element-1897">
                El error que hace que los productos con IA{' '}
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#FDB931] to-[#FFD700]" data-id="element-1898">
                  fallen antes de vender
                </span>
              </h1>
            </div>

            {/* Value Bullets */}
            <div className="bg-white/5 border border-white/10 rounded-2xl p-6 md:p-8 backdrop-blur-sm" data-id="element-1899">
              <div className="flex items-center gap-3 mb-6" data-id="element-1900">
                <AlertCircle className="text-[#FDB931] w-5 h-5" data-id="element-1901" />
                <p className="font-bold text-white text-sm md:text-base" data-id="element-1902">
                  Lo que descubrirás en esta sesión:
                </p>
              </div>
              <ul className="space-y-4" data-id="element-1903">
                {['Por qué el contenido bueno NO garantiza ventas', 'El error silencioso que mata la conversión al inicio', 'Qué debe estar claro antes de usar cualquier IA'].map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-300 text-sm md:text-base" data-id="element-1904">
                    <Check className="w-5 h-5 text-[#FDB931] shrink-0 mt-0.5" data-id="element-1905" />
                    <span data-id="element-1906">{item}</span>
                  </li>)}
              </ul>
            </div>

            {/* Bonus/Gift Tease */}
            <div className="flex items-center gap-4 p-4 rounded-xl bg-gradient-to-r from-gray-900 to-transparent border-l-4 border-[#FDB931]" data-id="element-1907">
              <div className="bg-[#FDB931]/10 p-2 rounded-lg shrink-0" data-id="element-1908">
                <BookOpen className="w-5 h-5 text-[#FDB931]" data-id="element-1909" />
              </div>
              <div data-id="element-1910">
                <p className="text-[#FDB931] font-bold text-sm uppercase" data-id="element-1911">
                  Incluye Regalo Exclusivo
                </p>
                <p className="text-gray-400 text-xs md:text-sm" data-id="element-1912">
                  Guía PDF: "Antes de Construir Cualquier Producto"
                </p>
              </div>
            </div>
          </div>

          {/* RIGHT COLUMN: Inline Form */}
          <div className="lg:col-span-5 w-full animate-in fade-in slide-in-from-bottom-12 duration-1000 delay-200" data-id="element-1913">
            <div className="bg-[#111] border border-white/10 rounded-3xl p-6 md:p-8 shadow-2xl shadow-black/50 relative overflow-hidden group" data-id="element-1914">
              {/* Subtle Glow Effect on Form */}
              <div className="absolute top-0 left-1/2 -translate-x-1/2 w-3/4 h-1 bg-gradient-to-r from-transparent via-[#FDB931] to-transparent opacity-50 blur-sm" data-id="element-1915"></div>

              <div className="text-center mb-8" data-id="element-1916">
                <h3 className="text-2xl font-black text-white uppercase mb-2" data-id="element-1917">
                  Acceso Inmediato
                </h3>
                <p className="text-gray-400 text-sm" data-id="element-1918">
                  Completa tus datos para desbloquear el entrenamiento.
                </p>
              </div>

              <form onSubmit={handleSubmit} className="space-y-5" data-id="element-1919">
                {/* Name */}
                <div className="space-y-1.5" data-id="element-1920">
                  <label className="text-[11px] font-bold text-gray-500 uppercase tracking-wider ml-1" data-id="element-1921">
                    Nombre
                  </label>
                  <div className="relative group/input" data-id="element-1922">
                    <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-1923">
                      <User className="h-5 w-5 text-gray-500 group-focus-within/input:text-[#FDB931] transition-colors" data-id="element-1924" />
                    </div>
                    <input type="text" value={name} onChange={e => setName(e.target.value)} placeholder="Tu nombre completo" required className="w-full pl-12 pr-4 py-4 rounded-xl bg-white/5 border border-white/10 text-white placeholder-gray-600 focus:outline-none focus:border-[#FDB931]/50 focus:bg-white/10 focus:ring-1 focus:ring-[#FDB931]/50 transition-all font-medium" data-id="element-1925" />
                  </div>
                </div>

                {/* Email */}
                <div className="space-y-1.5" data-id="element-1926">
                  <label className="text-[11px] font-bold text-gray-500 uppercase tracking-wider ml-1" data-id="element-1927">
                    Email
                  </label>
                  <div className="relative group/input" data-id="element-1928">
                    <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-1929">
                      <Mail className="h-5 w-5 text-gray-500 group-focus-within/input:text-[#FDB931] transition-colors" data-id="element-1930" />
                    </div>
                    <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="tu@email.com" required className="w-full pl-12 pr-4 py-4 rounded-xl bg-white/5 border border-white/10 text-white placeholder-gray-600 focus:outline-none focus:border-[#FDB931]/50 focus:bg-white/10 focus:ring-1 focus:ring-[#FDB931]/50 transition-all font-medium" data-id="element-1931" />
                  </div>
                </div>

                {/* Phone */}
                <div className="space-y-1.5" data-id="element-1932">
                  <label className="text-[11px] font-bold text-gray-500 uppercase tracking-wider ml-1" data-id="element-1933">
                    WhatsApp
                  </label>
                  <div className="flex gap-3" data-id="element-1934">
                    <div className="relative w-[35%] group/input" data-id="element-1935">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1936">
                        <Globe className="h-4 w-4 text-gray-500 group-focus-within/input:text-[#FDB931]" data-id="element-1937" />
                      </div>
                      <select value={areaCode} onChange={e => setAreaCode(e.target.value)} className="w-full pl-9 pr-2 py-4 rounded-xl bg-white/5 border border-white/10 text-white focus:outline-none focus:border-[#FDB931]/50 focus:bg-white/10 focus:ring-1 focus:ring-[#FDB931]/50 transition-all appearance-none text-sm font-medium cursor-pointer" data-id="element-1938">
                        {COUNTRY_CODES.map(country => <option key={country.code} value={country.code} className="bg-gray-900 text-white" data-id="element-1939">
                            {country.code}
                          </option>)}
                      </select>
                    </div>
                    <div className="relative w-[65%] group/input" data-id="element-1940">
                      <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none" data-id="element-1941">
                        <Phone className="h-5 w-5 text-gray-500 group-focus-within/input:text-[#FDB931] transition-colors" data-id="element-1942" />
                      </div>
                      <input type="tel" value={phone} onChange={e => setPhone(e.target.value.replace(/\D/g, ''))} placeholder="Número" required className="w-full pl-12 pr-4 py-4 rounded-xl bg-white/5 border border-white/10 text-white placeholder-gray-600 focus:outline-none focus:border-[#FDB931]/50 focus:bg-white/10 focus:ring-1 focus:ring-[#FDB931]/50 transition-all font-medium" data-id="element-1943" />
                    </div>
                  </div>
                </div>

                {/* Submit Button */}
                <button type="submit" disabled={isSubmitting} className="group relative w-full bg-[#FDB931] hover:bg-[#E6A02E] text-black font-black uppercase tracking-wide rounded-xl py-4 mt-4 shadow-[0_0_20px_rgba(253,185,49,0.2)] hover:shadow-[0_0_30px_rgba(253,185,49,0.4)] transition-all duration-300 transform hover:-translate-y-0.5 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none overflow-hidden" data-id="element-1944">
                  <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-1945">
                    {isSubmitting ? 'Procesando...' : 'Ver Entrenamiento Ahora'}
                    {!isSubmitting && <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-1946" />}
                  </span>

                  {/* Shine Effect */}
                  <div className="absolute top-0 -inset-full h-full w-1/2 z-5 block transform -skew-x-12 bg-gradient-to-r from-transparent to-white opacity-40 group-hover:animate-shine" data-id="element-1947" />
                </button>

                <div className="flex items-center justify-center gap-2 text-[10px] text-gray-500" data-id="element-1948">
                  <Lock className="w-3 h-3" data-id="element-1949" />
                  <span data-id="element-1950">Tus datos están 100% seguros y protegidos.</span>
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* Footer Links */}
        <div className="mt-16 lg:mt-24 pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4 text-[10px] text-gray-600" data-id="element-1951">
          <p data-id="element-1952">&copy; 2025 48 Hrs AI Cash Machine.</p>
          <div className="flex items-center gap-6" data-id="element-1953">
            <button onClick={() => setShowTerms(true)} className="hover:text-gray-400 transition-colors" data-id="element-1954">
              Términos
            </button>
            <button onClick={() => setShowPrivacy(true)} className="hover:text-gray-400 transition-colors" data-id="element-1955">
              Privacidad
            </button>
            <a href="mailto:support@truemarketer.com" className="hover:text-gray-400 transition-colors" data-id="element-1956">
              Soporte
            </a>
          </div>
        </div>
      </main>

      {/* Terms Modal */}
      {showTerms && <div className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4 backdrop-blur-sm" onClick={() => setShowTerms(false)} data-id="element-1957">
          <div className="bg-[#111] border border-white/10 rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto p-6 md:p-8 relative shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-1958">
            <button onClick={() => setShowTerms(false)} className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors" data-id="element-1959">
              <X className="w-6 h-6" data-id="element-1960" />
            </button>
            <h2 className="text-2xl font-bold mb-6 text-white" data-id="element-1961">
              Términos y Condiciones
            </h2>
            <div className="text-gray-400 text-sm space-y-4 leading-relaxed" data-id="element-1962">
              <p data-id="element-1963">
                Al registrarte y participar en el 48 Hrs AI Cash Machine
                Masterclass, aceptas los siguientes términos:
              </p>
              <h3 className="text-white font-bold mt-4" data-id="element-1964">1. Uso Educativo</h3>
              <p data-id="element-1965">
                El contenido es solo para fines educativos. No garantizamos
                resultados específicos.
              </p>
              <h3 className="text-white font-bold mt-4" data-id="element-1966">
                2. Propiedad Intelectual
              </h3>
              <p data-id="element-1967">
                Todo el material es propiedad de 48 Hrs AI Cash Machine.
                Prohibida su reproducción.
              </p>
              <h3 className="text-white font-bold mt-4" data-id="element-1968">3. Responsabilidad</h3>
              <p data-id="element-1969">
                No somos responsables de decisiones comerciales tomadas basadas
                en esta información.
              </p>
            </div>
          </div>
        </div>}

      {/* Privacy Modal */}
      {showPrivacy && <div className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4 backdrop-blur-sm" onClick={() => setShowPrivacy(false)} data-id="element-1970">
          <div className="bg-[#111] border border-white/10 rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto p-6 md:p-8 relative shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-1971">
            <button onClick={() => setShowPrivacy(false)} className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors" data-id="element-1972">
              <X className="w-6 h-6" data-id="element-1973" />
            </button>
            <h2 className="text-2xl font-bold mb-6 text-white" data-id="element-1974">
              Política de Privacidad
            </h2>
            <div className="text-gray-400 text-sm space-y-4 leading-relaxed" data-id="element-1975">
              <p data-id="element-1976">En 48 Hrs AI Cash Machine protegemos tu información:</p>
              <h3 className="text-white font-bold mt-4" data-id="element-1977">1. Recopilación</h3>
              <p data-id="element-1978">
                Solo recopilamos los datos necesarios para brindarte acceso al
                entrenamiento.
              </p>
              <h3 className="text-white font-bold mt-4" data-id="element-1979">2. Uso</h3>
              <p data-id="element-1980">
                Usamos tus datos para enviarte el material prometido y
                comunicaciones relevantes.
              </p>
              <h3 className="text-white font-bold mt-4" data-id="element-1981">3. No Spam</h3>
              <p data-id="element-1982">No vendemos ni compartimos tu información con terceros.</p>
            </div>
          </div>
        </div>}
    </div>;
}